<div class="wrapper flex flex-col justify-between">
  <div class="heading flex flex-row items-center justify-between mb-[40px]">
    <div class="text-type-2">
      {{ data?.id || data?.uuid ? (data?.name || data?.value || 'Edit external lab') : 'Add external lab' }}
    </div>
  </div>
  <div class="details flex-1">
    <app-text-input
      (checkForErrors)="checkForErrors($event)"
      [error]="errorMessages['name']"
      [parentFormGroup]="form"
      class="w-full mb-[20px]"
      controlName="name"
      label="Lab Name"
      />

    <!-- Contacts Section -->
    <div class="contacts-section">
      <div class="contacts-header text-type-13 uppercase mb-[12px]">
        Contacts
      </div>

      <div class="contacts-list flex flex-col gap-[16px]">
        @for (contactGroup of contacts.controls; track contactGroup; let i = $index) {
          <div class="contact-accordion border-[1px] border-[#C2C8DC] rounded-[4px] p-[16px]">
            <div class="contact-header flex justify-between items-center mb-[12px]">
              <div class="text-type-13 uppercase">Contact {{ i + 1 }}</div>
              @if (contacts.length > 1) {
                <mat-icon
                  (click)="removeContact(i)"
                  class="delete-icon cursor-pointer"
                  svgIcon="trash"
                  />
              }
            </div>
            <div class="contact-fields">
              <app-text-input
                [error]="contactErrorMessages[i]?.name"
                [parentFormGroup]="getContactGroup(i)"
                class="w-full mb-[10px]"
                controlName="name"
                label="Name"
                />
              <app-number-input
                [error]="contactErrorMessages[i]?.phone"
                [parentFormGroup]="getContactGroup(i)"
                class="w-full mb-[10px]"
                controlName="phone"
                label="Phone"
                />
              <app-text-input
                [error]="contactErrorMessages[i]?.email"
                [parentFormGroup]="getContactGroup(i)"
                class="w-full mb-[10px]"
                controlName="email"
                label="Email"
                />
            </div>
          </div>
        }
      </div>

      <div
        (click)="addContact()"
        class="add-contact flex justify-center items-center gap-[8px] mt-[16px] cursor-pointer"
        >
        <mat-icon class="add-icon" svgIcon="plus" />
        <span class="text-type-13">Add Contact</span>
      </div>
    </div>
  </div>
  <div class="action-section w-full flex justify-between items-center gap-[10px] mt-[40px]">
    <app-primary-button (handleClick)="submit()" [isDisabled]="!isFormDirty" class="w-full">
      Submit
    </app-primary-button>
  </div>
</div>
